export default __webpack_public_path__ + "static/media/playCircleIc.3fce3ff2.svg";